import { render, staticRenderFns } from "./FormSalva.vue?vue&type=template&id=5abc5410"
import script from "./FormSalva.vue?vue&type=script&lang=js"
export * from "./FormSalva.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports